import { z } from "zod";
import { UnitedStates } from "../enums/UnitedStates";

export const AddressSchema = z.object({
  street: z.string().max(250).optional(),
  city: z.string().max(250).optional(),
  zipCode: z.string().max(5).optional(),
  state: UnitedStates.optional(),
});

export type Address = z.infer<typeof AddressSchema>;
